export default __webpack_public_path__ + "static/media/(80).8c997544.jpg";